<template>
  <main id="register-wrapper">

    <div class="messagebox">
            <div class="loading loading-double"></div>
            <h4>Mohon menunggu sedang dalam proses login</h4>
    </div>
    
  </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";
export default {
  components: {
    breadcrumb: BreadCrumb,
    "v-select": vSelect,
  },
  data() {
    return {
        base_url:'',
        app_url:'',
        api_url:'',
        main_site_url:main_site_url,
        mobile: false,
    }
  },
  created() {
    this.base_url = base_url;
    this.app_url = app_url;
    this.api_url = api_url;
    this.mobile = isMobile;
    this.getUser();
  },
  methods: {
    onSubmit() {
      this.submitLoader = true;
      this.form.post(api_url+"/member/update")
        .then((response) => {
            this.submitLoader = false;
            if(response.status){
               localStorage.setItem('register-success', true);
               localStorage.setItem('user',JSON.stringify(response.data.data))
               this.$router.push({ path: '/community/success-register'});
            }
        })
        .catch((response) => {
          this.submitLoader = false;
          console.log("ERROR");
        });
    },
    getUser() {
            axios.get(api_url+'/member/profile').then(response => {
                    if(response.data.success){
                      localStorage.setItem('user',JSON.stringify(response.data.data))
                    }
                }).catch(error => {
                    this.loadderforms = false;
                   window.location.href = this.app_url + '/login'
                    console.log(error);
                });
    },
  },
};
</script>
<style lang="scss">
.colpage{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    .pageform{
        display: flex;
        justify-content: center;
        align-items: center;
        margin:0 20px;
        .numberpage{
            display: block;
            width: 35px; height: 35px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color:#4F4F4F;
            border-radius:100px;
            font-weight: bold;
        }
        .infopage{
            font-weight: bold;
            color:#4F4F4F;
            margin-left: 15px;
        }
    }
    .pageform.active{
        .numberpage{
            background-color:#7AE798;
        }
        .infopage{
            color:#7AE798;
        }
    }
}
  #registerpage{
    .vue-input-tag-wrapper .input-tag {
      background: #282828;
      border-radius: 10px;
      color: #FFFFFF;
      align-self: center;
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 24px;
      padding: 5px 1rem 5px 1rem !important;
      margin-bottom: 0px;
    }
    @media (max-width: 768px) {
      .vue-input-tag-wrapper .input-tag {
        background: #E61B33;
        line-height: 22px;
        height: 25px;
        padding: 0px 1rem 0px 1rem !important;
      }
    }
  }
</style>
<style scoped lang="scss">
#registerpage {
  background: #000000;
  font-family: Manrope;
  .card {
    background: #ffffff;
    border-radius: 10px;
    /* font-family: Inter; */
  }
  .title {
    color: #000000;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 1rem;
  }
  .label-form {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    color: #3f3f3f;
  }
  .form-register {
    border-radius: 10px;
    border: 1px solid #dbdbdb;
    box-sizing: border-box;
    padding:11px;
    height: auto;
  }
  ::placeholder {
    color: #727272;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url(/images/arrow-select.png) no-repeat right white;
    background-position-x: 98.5%;
  }
  .form-check {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 22px;
    color: #000000;
  }

  .btn {
    width: 161px;
    height: 50px;
  }
  .btn-white {
    border: 1px solid #dbdbdb;
    box-sizing: border-box;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #e61b33;
  }
  .btn-red {
    background: #e61b33;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
  }
  .title-row {
    background: #191919;
    opacity: 0.95;
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 42px;
    color: #ffffff;
  }
  .title-row-info {
    background: #1e1e1e;
  }
  .modal-content {
    background: #ffffff;
    border-radius: 10px;
  }
  .modal-header {
    border-bottom: unset;
  }
  .modal-title {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #e61b33;
  }
  .breadcrumb-image {
    max-height: 25px;
    display: inline-flex;
  }
  .breadcrumb-image-mobile {
    max-height: 25px;
    display: none;
  }
  .fa {
    cursor: pointer;
  }
  .fa-active {
    color: #4f4f4f;
  }
  .fa-not-active {
    color: #b4b4b4;
  }
  .row-eye {
    right: 35px;
    bottom: 155px;
    position: absolute;
    z-index: 1;
  }
  .row-password-eye {
    right: 35px;
    bottom: 265px;
    position: absolute;
    z-index: 1;
  }
  @media (max-width: 768px) {
    select {
      background-position-x: 95.5%;
    }
    .title {
      font-size: 18px;
    }
    .label-form {
      font-weight: 300;
    }
    .form-register {
      height: 40px;
    }
    .row-password-eye {
      bottom: 240px;
    }
    .row-eye {
      bottom: 145px;
    }
    .btn {
      width: 120px;
    }
    .modal-body {
      padding-left: 1.5rem !important;
      padding-right: 1.5rem !important;
    }
    .breadcrumb-image {
      display: none;
    }
    .breadcrumb-image-mobile {
      display: inline-flex;
    }
  }
}
</style>
